import type { MaybeComputedElementRef } from "@vueuse/core";

export function useWithinTeleport(el: MaybeComputedElementRef) {
  const withinTeleport = ref(false);

  watchEffect(() => {
    const unrefed = unrefElement(el);
    if (unrefed) {
      withinTeleport.value = !!unrefed.closest("#teleported");
    }
  });

  return { withinTeleport };
}
